export enum ROUTES {
  display = 'display',
  manage = 'manage',
  session = 'session',
}
